module.exports = __webpack_public_path__ + "static/media/bmp-icon.c00540ac.svg";